import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './Technologies.m.css';

const tech = {
	typescript: {
		icon: require('../assets/images/logo/technology/icon-framework-ts.svg'),
		title: 'TypeScript'
	},
	angular: {
		icon: require('../assets/images/logo/technology/icon-framework-angular.svg'),
		title: 'Angular'
	},
	dstore: {
		icon: require('../assets/images/logo/technology/icon-dstore.svg'),
		title: 'Dstore'
	},
	dgrid: {
		icon: require('../assets/images/logo/technology/icon-dgrid.svg'),
		title: 'Dgrid'
	},
	'dojo-toolkit': {
		icon: require('../assets/images/logo/technology/icon-dojo-toolkit.svg'),
		title: 'Dojo Toolkit'
	},
	rxjs: {
		icon: require('../assets/images/logo/technology/icon-framework-rxjs.svg'),
		title: 'RxJS'
	},
	protractor: {
		icon: require('../assets/images/logo/technology/icon-framework-protractor.svg'),
		title: 'Protractor'
	},
	karma: {
		icon: require('../assets/images/logo/technology/icon-framework-karma.svg'),
		title: 'Karma'
	},
	intern: {
		icon: require('../assets/images/logo/technology/icon-intern.svg'),
		title: 'Intern'
	},
	spring: {
		icon: require('../assets/images/logo/technology/icon-spring-framework.svg'),
		title: 'Spring Framework'
	},
	jasmine: {
		icon: require('../assets/images/logo/technology/icon-framework-jasmine.svg'),
		title: 'Jasmine'
	},
	java: {
		icon: require('../assets/images/logo/technology/icon-framework-java.svg'),
		title: 'Java'
	},
	javascript: {
		icon: require('../assets/images/logo/technology/icon-javascript.svg'),
		title: 'Javascript'
	},
	react: {
		icon: require('../assets/images/logo/technology/icon-react.svg'),
		title: 'React'
	},
	jest: {
		icon: require('../assets/images/logo/technology/icon-jest.svg'),
		title: 'Jest'
	},
	mobx: {
		icon: require('../assets/images/logo/technology/icon-mobx.svg'),
		title: 'MobX'
	},
	'react-native': {
		icon: require('../assets/images/logo/technology/icon-react-native.svg'),
		title: 'React Native'
	},
	redux: {
		icon: require('../assets/images/logo/technology/icon-redux.svg'),
		title: 'Redux'
	},
	php: {
		icon: require('../assets/images/logo/technology/icon-php.svg'),
		title: 'PHP'
	},
	canjs: {
		icon: require('../assets/images/logo/technology/icon-canjs.svg'),
		title: 'CanJS'
	},
	adobe: {
		icon: require('../assets/images/logo/technology/icon-adobe-em.svg'),
		title: 'Adobe Experience Manager'
	},
	junit: {
		icon: require('../assets/images/logo/technology/icon-junit.svg'),
		title: 'JUnit'
	},
	mockito: {
		icon: require('../assets/images/logo/technology/icon-mockito.svg'),
		title: 'Mockito'
	},
	'open-agent-policy': {
		icon: require('../assets/images/logo/technology/icon-open-policy-agent.svg'),
		title: 'Open Agent Policy'
	},
	splunk: {
		icon: require('../assets/images/logo/technology/icon-splunk.svg'),
		title: 'Splunk'
	},
	gemfire: {
		icon: require('../assets/images/logo/technology/icon-gemfire.svg'),
		title: 'Gemfire'
	},
	kafka: {
		icon: require('../assets/images/logo/technology/icon-kafka.svg'),
		title: 'Kafka'
	},
	tibco: {
		icon: require('../assets/images/logo/technology/icon-tibco-ems.svg'),
		title: 'Tibco EMS'
	},
	aws: {
		icon: require('../assets/images/logo/technology/icon-aws.svg'),
		title: 'Amazon Web Services'
	}
};

interface TechnologiesProperties {
	icons?: (keyof typeof tech)[];
}

const factory = create().properties<TechnologiesProperties>();

export const Technologies = factory(function Technologies({ properties }) {
	const { icons } = properties();
	return (
		<div classes={[css.root]}>
			<span classes={[css.title]}>Technologies Involved</span>
			<div classes={[css.icons]}>
				{icons &&
					icons.map((icon) => (
						<span classes={[css.item]}>
							<img
								classes={[css.icon]}
								src={tech[icon].icon}
								alt={icon}
								width={17}
								height={16}
							/>
							{tech[icon].title}
						</span>
					))}
			</div>
		</div>
	);
});

export default Technologies;
